import { LocationPhases } from '@/lib/locations';

import { MarketingModuleDto } from './modules';

export type MarketingPageDto = {
  slug: string;
  metaTitle: string;
  metaDescription: string;
  metaImage: string;
  campaignId?: string;
  formName?: string;
  isNavigationTransparent?: boolean;
  isCrawlable?: boolean;
  promoCode?: string;
  locationSlugs?: string[];
  phases?: LocationPhases[];
  modules: MarketingModuleDto[];
};

export enum ItemsTextForIcons {
  // WIFI icon
  HIGH_SPEED_WIFI = 'High-Speed Wi-Fi',
  FAST_SECURE_WiFi = 'Fast, Secure Wi-Fi',
  HIGH_SPEED_INTERNET = 'High-Speed Internet for On-Site Visits',
  // Conference icon
  CONFERENCE_PHONE_SYSTEMS = 'Conference Phone Systems',
  PRIVATE_CONFERENCE_ROOMS = 'Private Conference Rooms',
  ON_DEMAND_MEETING_ROOMS = 'On-Demand Meeting Rooms',
  // Reception icon
  PROFESSIONAL_RECEPTION_SERVICES = 'Professional Reception Services',
  VIRTUAL_RECEPTIONIST_SERVICES = 'Virtual Receptionist Services',
  // AV icon
  AV_EQUIPMENT = 'A/V Equipment',
  // Seating icon
  COMFORTABLE_SEATING = 'Comfortable Seating',
  // Printing icon
  PRINTING_OFFICE_SUPPLIES = 'Printing & Office Supplies',
  UNLIMITED_COLOR_PRINTING = 'Unlimited Color Printing',
  // Presentation icon
  WHITEBOARDS_PRESENTATION_TOOLS = 'Whiteboards & Presentation Tools',
  // Coffee icon
  COMPLIMENTARY_DRINKS = 'Complimentary Coffee, Tea, and Soda',
  DAILY_BREAKFAST_CRAFT_COFFEE = 'Daily Breakfast and Craft Coffee',
  // On-site icon
  ON_SITE_MANAGER = 'On-site Member Experience Manager',
  // People meeting icon
  PRESTIGIOUS_BUSINESS_ADDRESS = 'Prestigious Business Address',
  // Mail icon
  MAIL_PACKAGING_SERVICES = 'Mail and Packaging Services',
  PROFESSIONAL_MAIL_HANDLING = 'Professional Mail Handling and Forwarding',
  // Cleaning icon
  PROFESSIONAL_GRADE_CLEANINGS = 'Professional-Grade Cleanings',
  // Catering icon
  OFFICE_SUPPLIES = 'Office Supplies',
  // Events icon
  PROGRAMMING_EVENTS = 'Programming and Events',
  ACCESS_TO_NETWORKING_EVENTS = 'Access to Networking Events',
  // Phone icon
  PHONE_BOOTHS = 'Phone Booths',
}
